import React from "react";
import { Link } from "react-router-dom";
import { policies } from "../policies";
import { storeText } from "../config/storeConfig";
import "../css/policy.scss";

function PolicyLibrary() {
  return (
    <main className="policy-page policy-library main">
      <header className="policy-library__header">
        <p className="policy-kicker">Clear rules for real store features</p>
        <h1>Policy Library</h1>
        <p>Independent policies for data, ordering, products, delivery, safety and support.</p>
      </header>
      <div className="policy-grid">
        {policies.map((policy) => (
          <Link key={policy.slug} to={`/policies/${policy.slug}`} className="policy-tile">
            <h2>{policy.title}</h2><p>{storeText(policy.summary)}</p><span>Read policy <span aria-hidden="true">→</span></span>
          </Link>
        ))}
      </div>
    </main>
  );
}

export default PolicyLibrary;
